import React, { useState } from 'react'
import { Button, Spin } from 'antd'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import Sider from 'antd/es/layout/Sider'
import { MenuList } from 'components/common'
import useAuth0PermissionLevel from 'hooks/useUserPermissionLevel'
import { useAuth0 } from '@auth0/auth0-react'

export const SiderMenu: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0()
  const { userPermission, permissionLoading } = useAuth0PermissionLevel()
  const [collapsed, setCollapsed] = useState(false)

  const toggleCollapsed = () => {
    setCollapsed(!collapsed)
  }

  const contentStyle: React.CSSProperties = {
    padding: 1000,
    background: 'rgba(0, 0, 0, 0.05)',
    borderRadius: 4,
  };
  const content = <div style={contentStyle} />;

  return (
    <>
      <Sider className="sidebar" collapsed={collapsed}>
        {isLoading || permissionLoading ? (
          <Spin
            size="large"
            spinning={true}
            tip="Loading..."
          >
            {content}
          </Spin>
        ) : (
          <>
            <Button
              className="menu"
              type="primary"
              onClick={toggleCollapsed}
              style={{ marginBottom: 16 }}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </Button>
            <MenuList
              isAuthenticated={isAuthenticated}
              userPermission={userPermission} />
          </>
        )}
      </Sider>
    </>
  )
}

export default SiderMenu
